export default __webpack_public_path__ + "static/novolyze-logo.3ec87b66.svg";